<template>
  <div id="footer" class="container-fluid">
    <p class="copy"> Copyright © 小金星国际教育集团  闽ICP备05018002号  技术支持：35.com</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.copy {
  color: #fff;
  font-size: 0.37rem;
  margin: 20px 0;
}
@media screen and (max-width: 997px) {
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue